/** Which recordings a scene plays.
 *
 * The map rotates through its overworld pieces - each plays one full pass and
 * hands over to the next, and a trip into a town moves it on too - and every
 * town has its faction's theme; the menu and the battle have none yet and
 * stay on the synthesised bed, which is also what a faction without a file
 * gets. The files and their loop points come from the generated table next
 * door.
 */

import type { Playlist, Scene, Track } from "@game/ui";

import { MUSIC_TRACKS } from "./musicTracks.js";
import { assetDir } from "../base.js";

/** Where the loop files are served from: `apps/web/public/music`. */
const MUSIC = assetDir("/music");

/**
 * The overworld pieces, in the order they rotate. The original first, so a new
 * game opens on the theme the map was written to; the two "hypnotic" pieces
 * follow.
 */
export const OVERWORLD_ROTATION: readonly string[] = Object.freeze([
  "overworld", "overworld2", "overworld2b",
]);

function track(name: string): Track | null {
  const t = MUSIC_TRACKS[name];
  return t === undefined ? null : { url: `${MUSIC}/${t.file}`, loopSeconds: t.loopSeconds };
}

export function trackFor(scene: Scene | null, faction: string | null): Playlist {
  if (scene === "adventure") {
    return OVERWORLD_ROTATION.map(track).filter((t): t is Track => t !== null);
  }
  if (scene === "town" && faction !== null) {
    const t = track(faction);
    return t === null ? [] : [t];
  }
  return [];
}
